import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import { useInfluencerTwitterAnalyticsPostQuery, useTwitterAnalyticsPostQuery } from '@anytag/graphql';
import { PostModal, usePostModalContext } from '../shared';

export type TemplatePostDetailsType = Pick<PostDetailsType, 'id' | 'mainSocialAccountId'>;

export interface TemplateProps {
  className?: string;
  isAnalytics?: boolean;
}

export const Template = ({ className, isAnalytics }: TemplateProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();
  const { closeModal, selectedPost } = usePostModalContext<TemplatePostDetailsType>();
  const { data, loading } = useInfluencerTwitterAnalyticsPostQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || isAnalytics,
    variables: {
      twitterAnalyticsPostId: Number(selectedPost?.id),
      socialAccountId: Number(selectedPost?.mainSocialAccountId)
    },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });
  const { data: analyticsData, loading: fetchingAnalyticsData } = useTwitterAnalyticsPostQuery({
    skip: !selectedPost?.id || !selectedPost?.mainSocialAccountId || !isAnalytics,
    variables: {
      twitterAnalyticsPostId: Number(selectedPost?.id),
      twitterAnalyticsAccountId: Number(selectedPost?.mainSocialAccountId)
    },
    onError: (error) => {
      closeModal?.();
      enqueueSnackbar(t(error.message), { variant: 'error' });
    }
  });

  const details = data?.influencerTwitterAnalyticsPost || analyticsData?.twitterAnalyticsPost;

  return (
    <PostModal.DetailsTemplate
      className={className}
      loading={loading || fetchingAnalyticsData}
      data={
        details
          ? {
              socialMedia: 'TWITTER',
              postUrl: details?.post?.postUrl,
              caption: details?.post?.content,
              postDate: details?.post?.postDate,
              images: details?.post?.images || [],
              comments:
                details?.post?.comments?.map((comment) => ({
                  content: comment.content,
                  username: comment.posterName
                })) || [],
              statistics: {
                likes: details?.post?.like,
                views: details?.post?.view,
                replies: details?.post?.reply,
                retweets: details?.post?.retweet,
                quoteTweet: details?.post?.quoteTweet,
                impressions: details?.post?.impression,
                engagement: details?.post?.engagement
              },
              info: {
                name: details?.username,
                avatar: details?.avatar,
                followers: details?.followers
              }
            }
          : undefined
      }
    />
  );
};
